import React, { useState } from 'react';
import ReusableSidebar from '../../components/sidebar/reusable-sidebar';
import { useUser } from '../../services/contexts/user-context';
import { MainContent } from '../../components/sidebar/sidebar.styles';
import EditProfile from './edit-profile';
import Loading from '../../components/loading';

const DefaultEditProfile = () => {
  const { user, isLoading } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() =>
    typeof window === 'undefined' || !window.matchMedia('(max-width: 768px)').matches
  );

  const handleToggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <ReusableSidebar
        isSidebarOpen={isSidebarOpen}
        handleToggleSidebar={handleToggleSidebar}
        selectedPage="edit-profile"
        user={user}
        loading={isLoading}
      />

      <MainContent isSidebarOpen={isSidebarOpen}>
        {isLoading ? <Loading /> : <EditProfile />}
      </MainContent>
    </>
  );
};

export default DefaultEditProfile;
